import {
  pinMessage,
  unpinMessage,
  updateInformationOfPinInDb,
} from "../actions";
import { EChannels } from "./EChannels";

class PinHandler {
  MAX_NUMBER_PINN_CHATS = 4;
  STORAGE_KEY = "pinInformation";
  NOT_ALLOWED_CHANNELS = [EChannels.VOICE, EChannels.WHATSAPPVOICE];

  isExcededMaxNumberOfPinnedChats(getState) {
    const { atdsimult } = getState();
    if (!Array.isArray(atdsimult)) {
      return false;
    }
    const numberOfPinnedChats = atdsimult.reduce((total, current) => {
      if (current.isPined) {
        return total + 1;
      }
      return total;
    }, 0);

    return numberOfPinnedChats >= this.MAX_NUMBER_PINN_CHATS;
  }

  isChatPinned(chat) {
    if (!Boolean(chat)) return false;
    return chat.isPined || false;
  }

  hasThisItemInStorage(idatendimento) {
    const pinInfos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(pinInfos)) return false;
    const pinInfosParsed = JSON.parse(pinInfos);
    return `${idatendimento}` in pinInfosParsed || false;
  }
  addPinInfoInStorage(idatendimento, isPined = false, idmidia = 5) {
    if (this.NOT_ALLOWED_CHANNELS.includes(parseInt(idmidia))) return;
    const pinInfos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(pinInfos)) {
      localStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify({ [`${idatendimento}`]: isPined }),
      );
      return;
    }
    localStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify({
        ...JSON.parse(pinInfos),
        [`${idatendimento}`]: isPined,
      }),
    );
  }

  removePinInfoInStorage(idatendimento) {
    const pinInfos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(pinInfos)) return;
    const hasThisId = pinInfos[`${idatendimento}`];
    if (!hasThisId) return;
    const pinInfosParsed = JSON.parse(pinInfos);
    delete pinInfosParsed[`${idatendimento}`];
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(pinInfosParsed));
  }

  pinChat(dispatch, idatendimento, avoidInsertionInDb = false, idmidia = 5) {
    this.addPinInfoInStorage(idatendimento, true, idmidia);
    dispatch(pinMessage(idatendimento));
    if (!avoidInsertionInDb) {
      updateInformationOfPinInDb(idatendimento, true);
    }
  }

  unpinChat(dispatch, idatendimento, avoidInsertionInDb = false, idmidia = 5) {
    this.addPinInfoInStorage(idatendimento, false, idmidia);
    dispatch(unpinMessage(idatendimento));
    if (!avoidInsertionInDb) {
      updateInformationOfPinInDb(idatendimento, false);
    }
  }

  isPinned(idatendimento) {
    if (!this.hasThisItemInStorage(idatendimento)) return false;
    const pinInfos = localStorage.getItem(this.STORAGE_KEY);
    const pinInfosParsed = JSON.parse(pinInfos);
    return pinInfosParsed[`${idatendimento}`] || false;
  }

  removeOldNoReadInfoInStorage(atdsimult) {
    const infos = localStorage.getItem(this.STORAGE_KEY);
    if (!Boolean(infos)) return;
    const hasAtdsimult = Array.isArray(atdsimult) && atdsimult.length > 0;
    if (!hasAtdsimult) return;
    const infosParsed = JSON.parse(infos);
    for (const item of Object.keys(infosParsed)) {
      const hasThisId = atdsimult.find(
        (atd) => parseInt(atd.idatendimento) === parseInt(item),
      );
      if (!hasThisId) {
        this.removePinInfoInStorage(item);
      }
    }
  }

  isAllowedChannel(midiaId) {
    return !this.NOT_ALLOWED_CHANNELS.includes(parseInt(midiaId));
  }
}

export const pinHandler = new PinHandler();
